import React, { useState } from "react";
import Slider from "react-slick";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

// Components
import { ArtworkEnquiryForm } from "../forms/artwork-enquiry";

const ArtworksSlideshowContainer = styled.div`
  width: 100%;
  height: 50svh;
  margin-bottom: 150px;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 860px) {
    height: 33svh;
  }

  @media (max-width: 480px) {
    height: 30svh;
  }
`;

const ArtworkSlide = styled.div`
  height: 50svh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;

  @media (max-width: 860px) {
    height: 33svh;
  }

  @media (max-width: 480px) {
    height: 30svh;
    padding: 0 10px;
    margin: 0 10px;
  }
`;

const Arrow = styled.div`
  width: 15vw;
  height: 100%;

  position: absolute;
  top: 0;
  bottom: 0;

  z-index: 10;

  display: block !important;

  &.next {
    right: 20px;
    cursor: e-resize;

    cursor: url(/icons/exhibition-arrow-next@1x.png) 9 9, e-resize !important;
    cursor: -webkit-image-set(
          url(/icons/exhibition-arrow-next@1x.png) 1x,
          url(/icons/exhibition-arrow-next@2x.png) 2x
        )
        9 9,
      e-resize !important;
  }

  &.prev {
    left: 20px;
    cursor: w-resize;

    cursor: url(/icons/exhibition-arrow-previous@1x.png) 9 9, w-resize !important;
    cursor: -webkit-image-set(
          url(/icons/exhibition-arrow-previous@1x.png) 1x,
          url(/icons/exhibition-arrow-previous@2x.png) 2x
        )
        9 9,
      w-resize !important;
  }

  @media (max-width: 767px) {
    width: 100px;
    display: none !important;
  }
`;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return <Arrow className="next" style={{ ...style }} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <Arrow className="prev" style={{ ...style }} onClick={onClick} />;
}

export const ArtworksSlideshow = ({
  artworks,
  artist,
  setIsArtworkEnquiryFormOpen,
  isArtworkEnquiryFormOpen,
}) => {
  // Flatten all items arrays from each artwork object
  const allItems = artworks
    ? artworks.flatMap((artwork) => artwork.items || [])
    : [];

  // Only enable infinite mode if there are enough slides (3+)
  // This prevents duplication issues when there are few slides
  const shouldInfinite = allItems.length >= 3;

  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: shouldInfinite,
    centerMode: false,
    slidesToShow: 1,
    swipeToSlide: true,
    slidesToScroll: 1,
    variableWidth: true,
    swipe: true,
    touchThreshold: 10,
    useTransform: false,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <>
      <ArtworksSlideshowContainer>
        <Slider {...settings}>
          {allItems.map((item, index) => {
            const aspectRatio = `${item.image?.gatsbyImageData?.width} / ${item.image?.gatsbyImageData?.height}`;

            return (
              <ArtworkSlide key={`single_artwork_${index}_bottom_of_page`}>
                {item.image && (
                  <GatsbyImage
                    style={{ aspectRatio }}
                    image={item.image.gatsbyImageData}
                    alt={item.alt || `Artwork ${index + 1}`}
                    loading={index <= 1 ? "eager" : "lazy"}
                    fetchpriority={index <= 1 ? "high" : ""}
                  />
                )}
              </ArtworkSlide>
            );
          })}
        </Slider>
      </ArtworksSlideshowContainer>

      {isArtworkEnquiryFormOpen && (
        <ArtworkEnquiryForm
          artist={artist}
          artwork={null}
          url={window.location.href}
          setIsArtworkEnquiryFormOpen={setIsArtworkEnquiryFormOpen}
        />
      )}
    </>
  );
};
